export default class Nudge {
    public label: string;
    public ctaText: string;
    public ctaLink: string;
    public icon: string;
    public id: string;

    constructor(label: string, icon: string, ctaText: string, ctaLink: string, id: string) {
        this.label = label;
        this.ctaLink = ctaLink;
        this.ctaText = ctaText;
        this.id = id;
        this.icon = icon;
    }
}
